function AddTocartRecomended(id) {
    let qty_input = document.querySelector(`.qty_input-${id}`).value;
    
    // Use unified cart utility
    window.CartUtils.addToCart({
        id: id,
        quantity: +qty_input,
        context: 'cart-drawer',
        onSuccess: (data) => {
            fetchCartSnippet();
            const cartCount = document.querySelector('.cart-count-bubble span');
            if (cartCount) {
                cartCount.innerHTML = +cartCount.innerHTML + 1;
            }
            const errorHandler = document.querySelector(`.error_handler-${id}`);
            if (errorHandler) {
                errorHandler.innerHTML = '';
            }
        },
        onError: (errorData) => {
            errorResponse(errorData.description, id);
        }
    });
}

const errorResponse = (message, id) => {
    document.querySelector(`.error_handler-${id}`).innerHTML = message;
}

const fetchCartSnippet = (target) => {
    function handleResponse() {
        let divEl = document.createElement("div");
        divEl.innerHTML = this.responseText;
        
        // FIXED: This was the bug - incorrect assignment
        let updCart = divEl.querySelector('#CartDrawer');
        
        if (updCart) {
            document.querySelector('#CartDrawer').innerHTML = updCart.innerHTML;
            
            // Update data attributes
            if (updCart.dataset.cartqty) {
                document.querySelector('#CartDrawer').dataset.cartqty = updCart.dataset.cartqty;
            }
            
            if (document.querySelector('.cart-count-bubble span')) {
                document.querySelector('.cart-count-bubble span').innerHTML = updCart.dataset.cartqty;
            }
        }
        
        target?.closest('quantity-input')?.querySelectorAll('button').forEach((el) => {
            el.removeAttribute('disabled');
        });
    }
    
    document.querySelector('.quantity-input')?.closest('quantity-input')?.querySelectorAll('button').forEach((el) => {
        el.setAttribute('disabled', '');
    });
    
    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", "/?sections=cart-drawer", true);
    request.send();
}

const displayAccordion = (el) => {
    let content = el.closest('.cart_accordion-item').querySelector(".cart_accordion-content");
    content.classList.toggle("active");
    if (content.style.display === "block") {
        content.style.display = "none";
        el.querySelector('svg').style.transform = 'unset';
    } else {
        content.style.display = "block";
        el.querySelector('svg').style.transform = 'rotate(90deg)';
    }
};

document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');
        return msie > 0 || trident > 0;
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function (event) {
        document.querySelector('#cart').submit();
    });
});

const disableButton = (el) => {
    el.setAttribute('disabled', '');
}

// Add missing changeQty function
const changeQty = (action, variantId, element) => {
    const input = document.querySelector(`.qty_input-${variantId}`);
    if (!input) return;
    
    let currentValue = parseInt(input.value) || 1;
    
    if (action === 'plus') {
        currentValue++;
    } else if (action === 'minus' && currentValue > 1) {
        currentValue--;
    }
    
    input.value = currentValue;
}

// Add missing outsideClick function  
const outsideClick = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.close) {
        cartDrawer.close();
    }
}

// Make fetchCartSnippet globally available
window.fetchCartSnippet = fetchCartSnippet;